import React from 'react'
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react'
import clsx from 'clsx'

interface SortableHeaderProps {
  label: string
  field: string
  currentField: string
  direction: 'asc' | 'desc'
  onToggle: (field: string) => void
  align?: 'left' | 'right'
}

const SortableHeader: React.FC<SortableHeaderProps> = ({ label, field, currentField, direction, onToggle, align = 'left' }) => {
  const isActive = currentField === field

  return (
    <th
      className={clsx(
        'px-4 py-3 text-xs font-semibold text-slate-500 dark:text-slate-300 uppercase tracking-wide cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700/60 select-none',
        align === 'right' ? 'text-right' : 'text-left'
      )}
      onClick={() => onToggle(field)}
    >
      <div className={clsx('flex items-center gap-1', align === 'right' && 'justify-end')}>
        {label}
        {!isActive && <ArrowUpDown className="h-3 w-3 text-slate-400 dark:text-slate-500" />}
        {isActive && direction === 'asc' && <ArrowUp className="h-3 w-3 text-blue-600 dark:text-blue-400" />}
        {isActive && direction === 'desc' && <ArrowDown className="h-3 w-3 text-blue-600 dark:text-blue-400" />}
      </div>
    </th>
  )
}

export default SortableHeader
